import React from 'react';
import { Box, Grid, Typography, Divider } from '@mui/material';

const steps = [
  {
    step: 1,
    title: "Sign up on Vertex Suite",
    description:
      "Create a Vertex Suite account and connect your official WhatsApp number to it. Get your business verified with Facebook Business Manager.",
    image: "https://cdn.dribbble.com/userupload/29925196/file/still-d08887fdab66fd34a0778b12961a790d.png?resize=400x0",
  },
  {
    step: 2,
    title: "Optimize your profile",
    description:
      "Upload your brand kit to reflect brand identity and import your contacts.",
    image: "https://everyonesocial.com/wp-content/uploads/2021/04/Optimizing-LinkedIn-Profile.png",
  },
  {
    step: 3,
    title: "Access Vertex Suite tools",
    description:
      "Set up all necessary features such as chatbots, drip marketing sequences, broadcasts, integrations, etc., for your marketing campaigns.",
    image: "https://www.lifewire.com/thmb/T1N_BSQKj8WC3QJGQlJkjnfMlmw=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/rustdesk-remote-access-8c0a705e92a2459295ab8ef6ae56f8f0.png",
  },
  {
    step: 4,
    title: "Provide user access",
    description:
      "Assign team roles such as Owner, Admin and Member to streamline operations.",
    image: "https://frontegg.com/wp-content/uploads/2022/06/User-Permissions-3.png",
  },
];

const CustomizationMobile = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#dceefa',
        padding: { xs: 3, sm: 4, md: 6 },
        minHeight: 'auto',
        display: {xs: 'flex', lg: 'none'},
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {/* Section Heading */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: 'bold',
          fontSize: { xs: '28px', sm: '32px', md: '40px' },
          color: '#1A1A3D',
          textAlign: 'center',
          mb: { xs: 4, sm: 6 },
        }}
      >
        How to Use Vertex Suite WhatsApp Marketing Software
      </Typography>

      {/* Steps */}
      {steps.map((step, index) => (
        <Box
          key={step.step}
          sx={{
            width: '100%',
            maxWidth: '1200px',
            mb: { xs: 4, sm: 6 },
          }}
        >
          <Grid
            container
            spacing={{ xs: 2, sm: 3, md: 4 }}
            direction={index % 2 === 0 ? 'row' : 'row-reverse'} // Alternate image and text position
            alignItems="center"
            justifyContent="center"
          >
            {/* Image */}
            <Grid item xs={12} sm={6} md={5}>
              <Box
                component="img"
                src={step.image}
                alt={`Step ${step.step} - ${step.title}`}
                sx={{
                  width: '100%',
                  maxWidth: '400px',
                  height: 'auto',
                  borderRadius: 2,
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                  objectFit: 'contain',
                  display: 'block',
                  mx: 'auto',
                }}
              />
            </Grid>

            {/* Text Content */}
            <Grid item xs={12} sm={6} md={7}>
              <Box
                sx={{
                  backgroundColor: '#c8e4f5',
                  borderRadius: 2,
                  padding: { xs: 2, sm: 3, md: 4 },
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                  position: 'relative',
                  textAlign: { xs: 'center', sm: 'left' },
                }}
              >
                {/* Step Indicator */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: '-20px',
                    left: { xs: '50%', sm: '20px' },
                    transform: { xs: 'translateX(-50%)', sm: 'none' },
                    backgroundColor: '#1A1A3D',
                    color: 'white',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '18px',
                    fontWeight: 'bold',
                  }}
                >
                  {step.step}
                </Box>

                {/* Step Title */}
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 'bold',
                    fontSize: { xs: '20px', sm: '22px', md: '24px' },
                    color: '#1A1A3D',
                    mb: 2,
                  }}
                >
                  {step.title}
                </Typography>

                {/* Step Description */}
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { xs: '14px', sm: '16px', md: '18px' },
                    color: '#333',
                    lineHeight: 1.6,
                  }}
                >
                  {step.description}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          {/* Divider between steps (not after the last step) */}
          {index < steps.length - 1 && (
            <Divider
              sx={{
                borderColor: '#1A1A3D',
                opacity: 0.2,
                my: { xs: 3, sm: 4 },
                width: '80%',
                mx: 'auto',
              }}
            />
          )}
        </Box>
      ))}
    </Box>
  );
};

export default CustomizationMobile;